export default {
  delete_success: "L'offre a été supprimée avec succès",
  delete_failed: "La suppression de l'offre a échoué",
  delete_confirm_title: 'Voulez-vous vraiment supprimer cette offre ?',
  delete_last_day_confirm_title:
    'La suppression du dernier jour restant supprimera cette offre. Voulez-vous continuer ?',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  qualifying_items: 'Articles éligibles',
  free_items: 'Articles offerts',
  all_day: 'Toute la journée',
  starts_on: 'Commence le {{date}}',
  ends_on: 'Se termine le {{date}}',
  ends_when_deleted: 'Se termine lors de la suppression',
  off: '{{amount}} de réduction',
  min_spend_value: 'Dépense min. : {{amount}}',
};
